<template>
  <MainTemplate>
    <row pt="30px">
      <grid-item xs="2" xl="2" v-if="!isMobile">
        <aside class="aside">
          <ul>
            <li v-for="(navItem, idx) in asideData" :key="idx">
              <span class="line" v-if="navItem.line"></span>
              <template v-else>
                <span class="green__dot" v-if="idx === 5 && getBonus"></span>
                <span class="green__dot" v-if="idx === 7 && getUser.new_message"></span>
                <router-link
                    active-class="active"
                    :to="{name: navItem.link, params: navItem.params}">
                  {{ navItem.title }}
                </router-link>
              </template>
            </li>
          </ul>
        </aside>
      </grid-item>
      <grid-item xs="12" xl="10">
        <transition name="zoom-fade" :key="$route.name" mode="out-in">
          <router-view></router-view>
        </transition>
      </grid-item>
    </row>
  </MainTemplate>
</template>

<script>
import MainTemplate from '../../../templates/MainTemplate'
import GridItem from '../../../components/grid/GridItem'
import Row from '../../../components/grid/Row'
import SocketMixin from "@/mixins/socket";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {MainTemplate, Row, GridItem},
  mixins: [SocketMixin],
  data() {
    return {
      asideData: [
        {link: 'master.cabinet.calendar', params: {calendar: 'rents'}, title: 'Календарь'},
        {link: 'master.cabinet.clients', title: 'Мои клиенты'},
        {link: 'master.cabinet.packages', title: 'Пакеты часов'},
        {link: 'master.cabinet.analytics', title: 'Аналитика'},
        {link: 'master.cabinet.portfolio', title: 'Портфолио'},
        {link: 'master.cabinet.bonus', title: 'Бонусная программа'},
        {line: true},
        {link: 'master.cabinet.messages', title: 'Сообщения'},
        {link: 'master.cabinet.notifications', title: 'Уведомления'},
        {line: true},
        {link: 'master.cabinet.settings', title: 'Настройки'},
        {link: 'master.cabinet.instruction', title: 'Инструкция'},
      ]
    }
  },
  beforeMount() {
    this.connectToSocket();
  },
  computed: {
    ...mapGetters(['getBonus', 'getUser']),
    isMobile() {
      return document.documentElement.clientWidth < 1170
    }
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    ...mapMutations(['setUser']),
    loadUser() {
      this.$api.auth.me().then(({data}) => this.setUser(data));
    },
  }
}
</script>

<style scoped lang="scss">
.aside {
  ul {
    list-style: none;

    li {
      position: relative;
      margin-bottom: 15px;

      a {
        font-family: "Open Sans", sans-serif;
        text-decoration: none;
        font-size: 16px;
        line-height: 1.5;
        color: #808080;

        &.active {
          font-weight: 600;
          color: #383838;
        }
      }
    }
  }

  .line {
    margin: 20px 0;
    height: 1px;
    width: 100%;
    background: #E5E5E5;
    display: block;
  }
}

.green__dot {
  position: absolute;
  left: -15px;
  display: block;
  width: 10px;
  height: 10px;
  background-color: #0F8A84;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
